import { render } from "./affiliatesTable.vue?vue&type=template&id=4cb65512"
import script from "./affiliatesTable.vue?vue&type=script&lang=js"
export * from "./affiliatesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__